import { styled } from 'styled-components';

const Tag = styled.div`
	height: 20px;
	padding: 3px 5px;
	border-radius: 6px;
	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	line-height: 14px;
	font-weight: bold;
	color: #000;
	background-color: #fff;
	transition:
		color 0.25s ease,
		background-color 0.25s ease;
	user-select: none;
`;

export { Tag };
